import React, { useState, useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  FileText, 
  Users, 
  Building2,
  Menu,
  X,
  Home,
  LogOut,
  User,
  Tag,
  Calendar,
  Eye,
  ChevronLeft,
  ChevronRight,
  TrendingUp
} from 'lucide-react';
import { AuthContext } from '../contexts/AuthContext';
import { nikaoColors } from '../theme/nikaoTheme';
import toast from 'react-hot-toast';

// Nikao logo as data URL (same as used in chartUtils)
const nikaoLogoDataUrl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxODMgMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM3MzVfMTU1MSkiPjxwYXRoIGQ9Ik01NS42OTQ3IDI3Ljg1MDdINDEuNjg5QzM5LjQ3NzIgMjcuODUwNyAzNy4zNTIxIDI3LjAwMjUgMzUuNzg4NCAyNS40OTE5TDMyLjAxMjggMjEuODQ0NUMzMS42NTg2IDIxLjUwMjMgMzEuNjU4NiAyMC45NTI2IDMyLjAxMjggMjAuNjE0MUwzNy4wODA4IDE1LjcxODFDMzcuNDM1IDE1LjM3NTkgMzguMDExNSAxNS4zNzU5IDM4LjM2MTkgMTUuNzIxN0w0MS40NjY3IDE4Ljg1NTlDNDMuMDQ1NSAyMC4zNDg0IDQ0LjMzMDQgMjEuNTQyMyA0NS4zODkyIDIyLjQ5OTdDNDguNDIyNCAyNS4yMzcxIDQ5LjU4NjcgMjYuMDE5NyA1MC4zMjUzIDI2LjIzODFDNTEuNzM4MyAyNy4yMzkyIDUzLjYyMjMgMjcuODU0MyA1NS42OTA5IDI3Ljg1NDNMNTUuNjk0NyAyNy44NTA3WiIgZmlsbD0iIzAwQkY4RiIvPjxwYXRoIGQ9Ik04OS4wMzM5IDMuMzEyNDhMNjYuMjY3NyAyNS4zMDYyQzY0LjU3OTYgMjYuOTM3IDYyLjI5NjIgMjcuODQ3MSA1OS45MTg2IDI3Ljg0NzFINTUuNjk4NEM1My42Mjk4IDI3Ljg0NzEgNTEuNzQ1OCAyNy4yMzE5IDUwLjMzMjggMjYuMjMwOEM1MC41NjI3IDI2LjI5NjQgNTAuNzUxMSAyNi4zMTA5IDUwLjkzNTcgMjYuMzEwOUM1MS40NDQ0IDI2LjMxMDkgNTEuOTQxOCAyNi4yMTI2IDUyLjQwMTUgMjYuMDI3QzUyLjg2NDkgMjUuODQxMyA1My4yODY5IDI1LjU3MiA1My42NDQ5IDI1LjIyNjJMNjEuNTYxNCAxNy41NzgyTDczLjcwMTkgNS44NDk2NkM3NS4zOSA0LjIxODg3IDc3LjY3MzQgMy4zMDg4NCA4MC4wNTEgMy4zMDg4NEg4OS4wMzM5VjMuMzEyNDhaIiBmaWxsPSIjMDA3N0I2Ii8+PHBhdGggZD0iTTMzLjMzNTQgMy4zMTI0OEg0Ny4zNDFDNDkuNTUyOCAzLjMxMjQ4IDUxLjY3OCA0LjE2MDYzIDUzLjI0MTcgNS42NzEyOUw1Ni44ODUzIDkuMTkxMzFDNTcuMjM5NSA5LjUzMzQ5IDU3LjIzOTUgMTAuMDgzMSA1Ni44ODUzIDEwLjQyMTdMNTEuODE3NCAxNS4zMTc3QzUxLjQ2MzIgMTUuNjU5OSA1MC44ODY3IDE1LjY1OTkgNTAuNTM2MyAxNS4zMTRMNDcuNTYzMyAxMi4zMDczQzQ1Ljk4NDUgMTAuODE0OCA0NC42OTk2IDkuNjIwODUgNDMuNjQwOCA4LjY2MzQ5QzQwLjYwNzYgNS45MjYxIDM5LjQ0MzMgNS4xNDM0NyAzOC43MDQ4IDQuOTI1MDZDMzcuMjkxOCAzLjkyNDAyIDM1LjQwNzggMy4zMDg4NCAzMy4zMzkyIDMuMzA4ODRMMzMuMzM1NCAzLjMxMjQ4WiIgZmlsbD0iIzAwQkY4RiIvPjxwYXRoIGQ9Ik0wIDI3Ljg1MDdMMjIuNzY2MiA1Ljg1MzMyQzI0LjQ1NDMgNC4yMjI1NCAyNi43Mzc3IDMuMzEyNSAyOS4xMTUzIDMuMzEyNUgzMy4zMzU0QzM1LjQwNCAzLjMxMjUgMzcuMjg4IDMuOTI3NjggMzguNzAxIDQuOTI4NzJDMzguNDcxMiA0Ljg2MzIgMzguMjgyOCA0Ljg0ODY0IDM4LjA5ODIgNC44NDg2NEMzNy41ODk1IDQuODQ4NjQgMzcuMDkyMSA0Ljk0NjkzIDM2LjYzMjQgNS4xMzI1N0MzNi4xNjg5IDUuMzE4MjIgMzUuNzQ2OSA1LjU4NzU5IDM1LjM4OSA1LjkzMzRMMjcuNDcyNCAxMy41ODE0TDE1LjMzMiAyNS4zMDk5QzEzLjY0MzkgMjYuOTQwNyAxMS4zNjA1IDI3Ljg1MDcgOC45ODI4OSAyNy44NTA3SDBaIiBmaWxsPSIjMDA3N0I2Ii8+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0iY2xpcDBfMzczNV8xNTUxIj48cmVjdCB3aWR0aD0iMTgzIiBoZWlnaHQ9IjI4IiBmaWxsPSJ3aGl0ZSIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPg==";

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);

  const navigation = [
    { name: 'Dashboard', href: '/', icon: Home },
    { name: 'SOW Management', href: '/sow', icon: FileText },
    { name: 'Forecast Revenue', href: '/forecast-revenue', icon: TrendingUp },
    { name: 'Available Days', href: '/available-days', icon: Calendar },
    { name: 'Actuals Management', href: '/actuals', icon: FileText },
    { name: 'Actuals Grouped View', href: '/actuals-grouped', icon: Eye },
    { name: 'Clients', href: '/clients', icon: Building2 },
    { name: 'Resources', href: '/resources', icon: Users },
    { name: 'Resource Types', href: '/resource-types', icon: Tag },
    { name: 'Users', href: '/users', icon: User },
  ];

  const isActive = (path) => location.pathname === path;

  const handleLogout = async () => {
    try {
      await logout();
      toast.success('Logged out successfully');
      navigate('/login');
    } catch (error) {
      toast.error('Error logging out');
    }
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 flex z-40 lg:hidden ${sidebarOpen ? '' : 'hidden'}`}>
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)}></div>
        <div className="relative flex w-full max-w-xs flex-1 flex-col bg-white">
          <div className="absolute top-0 right-0 -mr-12 pt-2">
            <button
              onClick={() => setSidebarOpen(false)}
              className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
            >
              <X className="h-6 w-6 text-white" />
            </button>
          </div>
          <div className="flex h-16 items-center px-4" style={{ backgroundColor: '#160e2b' }}>
            <div className="flex items-center">
              <img 
                src={nikaoLogoDataUrl} 
                alt="Nikao Logo" 
                style={{ 
                  height: '28px', 
                  width: '90px',
                  objectFit: 'contain'
                }}
              />
              <h1 className="text-xl font-bold text-white -ml-10">Nikao Profile</h1>
            </div>
          </div>
          <nav className="flex-1 space-y-1 px-2 py-4 bg-white">
            {navigation.map((item) => {
              const Icon = item.icon;
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`group flex items-center px-2 py-2 text-sm font-medium ${
                    isActive(item.href)
                      ? 'bg-gray-100 text-gray-900'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  }`}
                >
                  <Icon className="mr-3 h-5 w-5" />
                  {item.name}
                </Link>
              );
            })}
          </nav>
          {/* User info and logout in mobile sidebar */}
          <div className="border-t border-gray-200 p-4 bg-white">
            <div className="flex items-center mb-3">
              <div className="w-8 h-8 bg-[#0077B6] rounded-full flex items-center justify-center text-white text-sm font-medium">
                {user?.username?.charAt(0)?.toUpperCase() || 'U'}
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-gray-900">{user?.username || 'User'}</p>
                <p className="text-xs text-gray-500 capitalize">{user?.role || 'user'}</p>
              </div>
            </div>
            <button
              onClick={handleLogout}
              className="w-full flex items-center px-2 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900"
            >
              <LogOut className="mr-3 h-5 w-5" />
              Logout
            </button>
          </div>
        </div>
      </div>

      {/* Desktop sidebar */}
      <div className={`hidden lg:flex lg:flex-col transition-all duration-300 ${sidebarCollapsed ? 'lg:w-16' : 'lg:w-64'}`}>
        <div className="flex flex-col flex-grow bg-white border-r border-gray-200">
          <div className="flex h-16 items-center px-4 justify-between" style={{ backgroundColor: '#160e2b' }}>
            {!sidebarCollapsed && (
              <div className="flex items-center">
                <img 
                  src={nikaoLogoDataUrl} 
                  alt="Nikao Logo" 
                  className="mr-3"
                  style={{ 
                    height: '28px', 
                    width: 'auto',
                    objectFit: 'contain'
                  }}
                />
                <h1 className="text-xl font-bold text-white -ml-10">Nikao Profile</h1>
              </div>
            )}
            {sidebarCollapsed && (
              <div className="flex items-center justify-center w-full">
                <img 
                  src={nikaoLogoDataUrl} 
                  alt="Nikao Logo" 
                  style={{ 
                    height: '28px', 
                    width: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </div>
            )}
            <button
              onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
              className="text-white hover:text-gray-200 p-1 rounded"
            >
              {sidebarCollapsed ? <ChevronRight className="h-5 w-5" /> : <ChevronLeft className="h-5 w-5" />}
            </button>
          </div>
          <nav className="flex-1 space-y-1 px-2 py-4 bg-white">
            {navigation.map((item) => {
              const Icon = item.icon;
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`group flex items-center px-2 py-2 text-sm font-medium ${
                    isActive(item.href)
                      ? 'bg-gray-100 text-gray-900'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  } ${sidebarCollapsed ? 'justify-center' : ''}`}
                  title={sidebarCollapsed ? item.name : ''}
                >
                  <Icon className={`h-5 w-5 ${sidebarCollapsed ? '' : 'mr-3'}`} />
                  {!sidebarCollapsed && item.name}
                </Link>
              );
            })}
          </nav>
          {/* User info and logout in desktop sidebar */}
          <div className="border-t border-gray-200 p-4 bg-white">
            {!sidebarCollapsed && (
              <div className="flex items-center mb-3">
                <div className="w-8 h-8 bg-[#0077B6] rounded-full flex items-center justify-center text-white text-sm font-medium">
                  {user?.username?.charAt(0)?.toUpperCase() || 'U'}
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-gray-900">{user?.username || 'User'}</p>
                  <p className="text-xs text-gray-500 capitalize">{user?.role || 'user'}</p>
                </div>
              </div>
            )}
            {sidebarCollapsed && (
              <div className="flex items-center justify-center mb-3">
                <div className="w-8 h-8 bg-[#0077B6] rounded-full flex items-center justify-center text-white text-sm font-medium">
                  {user?.username?.charAt(0)?.toUpperCase() || 'U'}
                </div>
              </div>
            )}
            <button
              onClick={handleLogout}
              className={`w-full flex items-center px-2 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900 ${sidebarCollapsed ? 'justify-center' : ''}`}
              title={sidebarCollapsed ? 'Logout' : ''}
            >
              <LogOut className={`h-5 w-5 ${sidebarCollapsed ? '' : 'mr-3'}`} />
              {!sidebarCollapsed && 'Logout'}
            </button>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Top bar */}
        <div className="flex h-16 items-center justify-between px-4 lg:px-6" style={{ backgroundColor: '#160e2b' }}>
          <div className="flex items-center space-x-4">
            <button
              onClick={() => setSidebarOpen(true)}
              className="lg:hidden text-white hover:text-gray-200"
            >
              <Menu className="h-6 w-6" />
            </button>
            <h2 className="text-lg font-medium text-white">
              {navigation.find(item => isActive(item.href))?.name || 'Dashboard'}
            </h2>
          </div>
          {/* User info in top bar for mobile */}
          <div className="lg:hidden flex items-center space-x-2">
            <div className="w-6 h-6 bg-white rounded-full flex items-center justify-center text-[#0077B6] text-xs font-medium">
              {user?.username?.charAt(0)?.toUpperCase() || 'U'}
            </div>
            <button
              onClick={handleLogout}
              className="text-white hover:text-gray-200"
            >
              <LogOut className="h-5 w-5" />
            </button>
          </div>
        </div>

        {/* Page content */}
        <main className="flex-1 overflow-y-auto p-4 lg:p-6">
          {children}
        </main>
      </div>
    </div>
  );
};
export default Layout; 